module.exports = __webpack_public_path__ + "img/x-ray4.467352f4.jpg";